/* ============================================================================
   PÁGINA DE COLECCIÓN — CÓRDOBA EDITORIAL · comportamiento
   Reescrito desde cero el 2026-07-21.

   El lujo también es que la página no dependa de JavaScript. Aquí sólo hay
   tres cosas, todas prescindibles:

     1 · Aparición al hacer scroll (IntersectionObserver).
     2 · Cierre del desplegable "Ordenar" al pulsar fuera o con Escape.
         Abrirlo y elegir funciona sin JS: es un <details> con enlaces.
     3 · Empujón al autoplay del vídeo en Safari/iOS, que a veces lo deniega.

   Se re-arma solo cuando el editor de temas repinta la sección.
   ============================================================================ */
(function () {
  'use strict';

  var REDUCED =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- 1 · Aparición al hacer scroll ---------- */
  function initReveal(root) {
    var targets = root.querySelectorAll('.ced-reveal:not(.is-in)');
    if (!targets.length) return;

    var animate = root.getAttribute('data-animate') === 'true';
    if (!animate || REDUCED || !('IntersectionObserver' in window)) {
      for (var i = 0; i < targets.length; i++) targets[i].classList.add('is-in');
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.06 }
    );

    /* Lo que ya está a la vista se pinta sin esperar al observer: si por lo
       que sea no llega a disparar (vistas previas sin composición, motores
       raros), la primera pantalla nunca se queda en blanco. */
    targets.forEach(function (el) {
      if (el.getBoundingClientRect().top < window.innerHeight) {
        el.classList.add('is-in');
      } else {
        observer.observe(el);
      }
    });
  }

  /* ---------- 2 · Desplegable de orden ---------- */
  function initSort(root) {
    var sorts = root.querySelectorAll('[data-ced-sort]');
    if (!sorts.length) return;

    sorts.forEach(function (details) {
      if (details.dataset.cedBound === '1') return;
      details.dataset.cedBound = '1';

      details.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && details.open) {
          details.open = false;
          var summary = details.querySelector('summary');
          if (summary) summary.focus();
        }
      });
    });

    if (document.documentElement.dataset.cedSortDoc === '1') return;
    document.documentElement.dataset.cedSortDoc = '1';

    document.addEventListener('click', function (event) {
      document.querySelectorAll('[data-ced-sort][open]').forEach(function (details) {
        if (!details.contains(event.target)) details.open = false;
      });
    });
  }

  /* ---------- 3 · Autoplay del vídeo ---------- */
  function initVideo(root) {
    root.querySelectorAll('.ced-tile__video').forEach(function (video) {
      video.muted = true;
      var attempt = video.play();
      if (attempt && typeof attempt.catch === 'function') {
        attempt.catch(function () {
          /* Denegado: se queda el póster. No es un error que deba romper nada. */
        });
      }
    });
  }

  function init(scope) {
    var roots = (scope || document).querySelectorAll('.ced');
    roots.forEach(function (root) {
      initReveal(root);
      initSort(root);
      initVideo(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  /* El editor de temas reemplaza el HTML de la sección al tocar un ajuste. */
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
  document.addEventListener('shopify:block:select', function (event) {
    var cell = event.target.closest ? event.target.closest('.ced-reveal') : null;
    if (cell) cell.classList.add('is-in');
  });
})();
